import { Icon, type IconNameType } from "@src/components/Icon";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { NavPressable } from "@src/components/NavPressable";
import type { Href } from "expo-router";

interface SidepanelActionItemProps {
  label: string;
  icon: IconNameType;
  onPress: () => void;
  href?: Href;
  externalHref?: string;
  collapsed?: boolean;
  colorToken?: "icon" | "danger";
}

export function SidepanelActionItem({
  label,
  icon,
  onPress,
  href,
  externalHref,
  collapsed = false,
  colorToken = "icon",
}: SidepanelActionItemProps) {
  const { theme } = useUnistyles();
  const iconColor = colorToken === "danger" ? theme.colors.danger[400] : theme.colors.icon;

  if (collapsed) {
    return (
      <NavPressable
        onPress={onPress}
        href={href}
        externalHref={externalHref}
        style={{ padding: theme.spacing.lg, alignItems: "center" }}
      >
        <Icon name={icon} size={theme.spacing["5xl"]} color={iconColor} />
      </NavPressable>
    );
  }

  return (
    <NavPressable
      onPress={onPress}
      href={href}
      externalHref={externalHref}
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing.sm,
        paddingVertical: theme.spacing.lg,
        paddingHorizontal: theme.spacing.xl,
        borderRadius: theme.spacing.md,
      }}
    >
      <Icon name={icon} size={theme.spacing["5xl"]} color={iconColor} />
      <Text textStyle="sm/regular" color={colorToken === "danger" ? "danger" : "text"}>
        {label}
      </Text>
    </NavPressable>
  );
}
